var React = require('react');

function La (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fillOpacity":".7","d":"M0 0h640v480H0z"}))),React.createElement("g",{"fillRule":"evenodd","clipPath":"url(#a)","key":1},[React.createElement("path",{"fill":"#ce1126","d":"M-40 0h720v480H-40z","key":0}),React.createElement("path",{"fill":"#002868","d":"M-40 119.3h720v241.4H-40z","key":1}),React.createElement("path",{"fill":"#fff","d":"M423.4 240a103.4 103.4 0 1 1-206.8 0 103.4 103.4 0 1 1 206.8 0z","key":2})])]);
}

La.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = La;

La.default = La;
